import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import { Bar } from "react-chartjs-2"
import Title from "../general/title"
import times from "helpers/times"
import moment from "moment"
import general from "helpers/general"
import colorArray from "helpers/colorArray"
import monoColorArray from "helpers/monoColorArray"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import numeral from "numeral"
import settings from "settings"
import helpers from "helpers/helpers"

class Starts extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			model: {
				gross_sales_contract: 0,
				average_home_price: 0,
				average_square_feet: 0,
				average_ppsqft: 0,
				average_lot_price: 0,
				percent_lot_home: 0,
				total: 0,
				totalHomePrice: 0,
				totalSqft: 0,
				totalLotPrice: 0,
			},
			columns: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Month",
					accessor: "month",
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Starts",
					accessor: "starts",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
					Footer: (props) => helpers.tableTotals(props, "starts", "0,0"),
				},
			],
			builderLotTypeCombo: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Month",
					accessor: "monthNumber",
					Cell: (v) => {
						let mo = moment(v.value, "M").format("MMMM")
						return mo
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Builder and Lot Type",
					accessor: "builderLotType",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
				},
				{
					Header: "Starts",
					accessor: "starts",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
				},
			],
			builderLotType: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Month",
					accessor: "monthNumber",
					Cell: (v) => {
						let mo = moment(v.value, "M").format("MMMM")
						return mo
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Starts",
					accessor: "starts",
					filterMethod: (f, r) => helpers.tableText(f, r, "starts"),
					Footer: (props) => helpers.tableTotals(props, "starts", "0,0"),
				},
			],
			statusColumns: [
				{
					Header: "Community",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Lot",
					accessor: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot"),
				},
				{
					Header: "Block",
					accessor: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "Block"),
				},
				{
					Header: "Section",
					accessor: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "Section"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Start Date",
					accessor: "Start Date",
					filterMethod: (f, r) => helpers.tableText(f, r, "Start Date"),
				},
				{
					Header: "Floorplan",
					accessor: "Floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "Floorplan"),
				},
				{
					Header: "Elevation",
					accessor: "Elevation",
					filterMethod: (f, r) => helpers.tableText(f, r, "Elevation"),
				},
			],
			detailedStarts: [
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Section",
					accessor: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "Section"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Start Date",
					accessor: "Start Date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
				{
					Header: "Floorplan",
					accessor: "Floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "Floorplan"),
				},
				{
					Header: "Under Contract?",
					accessor: "under_contract",
					filterMethod: (f, r) => helpers.tableText(f, r, "under_contract"),
				},
			],
			buildTimeColumns: [
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Last Name",
					accessor: "last_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "last_name"),
				},
				{
					Header: "Takedown Date",
					accessor: "takedown_date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				},
				{
					Header: "Months Remaining",
					accessor: "months_remaining",
					filterMethod: (f, r) => helpers.tableText(f, r, "months_remaining"),
				},
			],
			statusSorted: [],
			ytd: [],
			monthly: [],
		}
	}

	buildData = () => {
		let store = {}
		let all = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.start_date < this.props.currentDates.startStamp || v.start_date > this.props.currentDates.endStamp) {
				return
			}
			all.push(v)
			let year = moment.unix(v.start_date).format("YYYY")
			let month = moment.unix(v.start_date).format("MMM").toUpperCase()
			let path = `${year}.${month}`
			if (!_.has(store, path)) {
				_.set(store, path, 0)
			}
			store[year][month]++
		})
		let byMonth = {}
		_.forEach(store, (row, year) => {
			_.forEach(general.monthsArrayAbbrev, (mon) => {
				_.set(byMonth, `${year}.${mon}`, row[mon])
			})
		})
		let c = _.cloneDeep(byMonth)
		let ytd = {}
		let ytdCumulative = {}
		_.forEach(c, (row, year) => {
			let count = 0
			_.forEach(row, (val, month) => {
				if (!val) {
					val = 0
				}
				count += val
				_.set(ytdCumulative, `${year}.${month}`, count)
			})
			count = 0
			_.forEach(row, (val, month) => {
				_.set(ytd, `${year}.${month}`, val)
			})
		})
		return { byMonth, ytd, ytdCumulative, all }
	}

	startsChart = () => {
		let data = this.buildData()
		let labels = []
		if (!_.isEmpty(data.byMonth)) {
			labels = Object.keys(data.byMonth[Object.keys(data.byMonth)[0]])
		}
		let datasets = []
		let i = 0
		let monthNum = moment.unix(this.props.currentDates.endStamp).month()
		_.forEach(data.ytdCumulative, (row, year) => {
			_.forEach(row, (val, month) => {
				let rowMonth = moment(month, "MMM").month()
				if (rowMonth > monthNum) {
					delete data.ytdCumulative[year][month]
				}
			})
		})
		_.forEach(data.ytdCumulative, (row, year) => {
			datasets.push({
				label: `YTD - ${year}`,
				type: "line",
				data: Object.values(row),
				backgroundColor: monoColorArray[i],
				borderColor: monoColorArray[i],
				yAxisID: "ytd",
				fill: false,
			})
			i++
		})
		i = 0
		_.forEach(data.byMonth, (row, year) => {
			datasets.push({
				label: `By Month - ${year}`,
				type: "bar",
				data: Object.values(row),
				backgroundColor: colorArray[i],
				yAxisID: "byMonth",
			})
			i++
		})

		const barData = {
			labels: labels,
			datasets: datasets,
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
			scales: {
				yAxes: [
					{
						id: "ytd",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: true,
							labelString: "YTD",
						},
					},
					{
						id: "byMonth",
						type: "linear",
						position: "left",
						scaleLabel: {
							display: true,
							labelString: "By Month",
						},
					},
				],
			},
		}

		return <Bar data={barData} options={opts} />
	}

	monthTable = () => {
		let data = this.buildData()
		let ret = []

		_.forEach(data.byMonth, (row, year) => {
			_.forEach(row, (v, month) => {
				let monthNumber = parseInt(moment(month, "MMM").format("M"))
				ret.push({
					year,
					month,
					monthNumber,
					starts: v,
				})
			})
		})
		return ret
	}

	/* byBuilderLotTypeCombo = () => {
		let ret = []
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.start_date < this.props.currentDates.startStamp || v.start_date > this.props.currentDates.endStamp) {
				return
			}
			let year = moment.unix(v.start_date).format("YYYY")
			let monthNumber = moment.unix(v.start_date).format("M")
			let path = `${year}.${monthNumber}.${v.builder_name} - ${v.lot_type_name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, 0, Object)
			}
			store[year][monthNumber][`${v.builder_name} - ${v.lot_type_name}`]++
		})
		console.log(store)
		_.forEach(store, (months, year) => {
			_.forEach(months, (builders, month) => {
				let monthText = moment(month, "M").format("MMMM")
				_.forEach(builders, (val, builder) => {
					ret.push({
						year,
						monthText,
						monthNumber: month,
						builderLotType: builder,
						starts: val,
					})
				})
			})
		})
		console.log(ret)
		return ret
	} */

	byBuilderLotType = () => {
		let ret = []
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			try {
				if (
					v.start_date < this.props.currentDates.startStamp ||
					v.start_date > this.props.currentDates.endStamp
				) {
					return
				}
				let year = moment.unix(v.start_date).format("YYYY")
				let monthNumber = moment.unix(v.start_date).format("M")
				let builder = helpers.safeString(v.builder_name)
				let path = `${year}.${monthNumber}.${builder}.${v.lot_type_name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, 0, Object)
				}
				store[year][monthNumber][builder][v.lot_type_name]++
			} catch (e) {
				console.log(e)
			}
		})
		_.forEach(store, (months, year) => {
			_.forEach(months, (builders, month) => {
				_.forEach(builders, (types, builder) => {
					_.forEach(types, (v, lotType) => {
						ret.push({
							year,
							monthNumber: month,
							monthText: moment(month, "M").format("MMMM"),
							builder,
							lot_type: lotType,
							starts: v,
						})
					})
				})
			})
		})
		return ret
	}

	detailedTable = () => {
		let data = this.buildData()
		let ret = []
		_.forEach(data.all, (v, year) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			ret.push({
				Builder: builder ? builder.name : "",
				"Lot Type": type ? type.name : "",
				Address: v.address,
				"Start Date": v.start_date,
				Floorplan: fp ? fp.name : "",
				under_contract: v.lot_status == "Contract" ? "Yes" : "No",
				Section: v.section_name,
				sqft: v.sqft ? numeral(v.sqft).format("0,0") : "",
			})
		})

		return ret
	}

	buildStatusTable = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let f = {
				Lot: v.lot,
				Block: v.block,
				Section: v.section_name,
				Community: property ? property.name : "",
				Address: v.address,
				"Start Date": v.start_date ? moment.unix(v.start_date).format("MM/DD/YY") : "",
				Floorplan: fp ? fp.name : "",
				Elevation: v.elevation,
			}
			ret.push(f)
		})
		return ret
	}

	getTrProps(state, rowInfo, instance) {
		if (rowInfo) {
			let v = rowInfo.original
			let months = parseInt(v.months_remaining)
			if (months <= 2) {
				return { className: "!bg-red-200" }
			} else if (months >= 3 && months <= 6) {
				return { className: "!bg-yellow-200" }
			} else if (months >= 7) {
				return { className: "!bg-green-200" }
			}
		}
		return {}
	}

	buildBuildTime = () => {
		let ret = []
		let monthsDeadline = settings?.enabled?.buildTime?.monthsDeadline
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (
				settings.enabled.buildTime.builders.includes(v.builder) &&
				v.takedown_date &&
				!v.start_date &&
				v.sale_id
			) {
				let between = moment().diff(moment.unix(v.takedown_date), "months")
				let months_remaining = monthsDeadline - between
				let f = {
					lot: v.lot,
					block: v.block,
					section: v.section_name,
					address: v.address,
					last_name: v.primary_last,
					takedown_date: v.takedown_date,
					months_remaining,
				}
				ret.push(f)
			}
		})
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Starts" />
						<div className="content">
							<div>
								<ImageExport name="Starts" />
								{this.startsChart()}
							</div>
							<h3>Monthly Starts</h3>
							<FullTable
								data={this.monthTable()}
								columns={this.state.columns}
								name="starts__months"
								title="Starts Months"
								pageSize={12}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							{/* <h3>By Builder + Lot Type Combo</h3>
							<FullTable
								data={this.byBuilderLotTypeCombo()}
								columns={this.state.builderLotType}
								name="starts__builderLotTypeCombo"
								title="Starts Builder Lot Type Combo"
								pageSize={12}
							/> */}
							<h3>By Builder and Lot Type</h3>
							<FullTable
								data={this.byBuilderLotType()}
								columns={this.state.builderLotType}
								name="starts__builderLotType"
								title="Starts Builder Lot Type"
								pageSize={12}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Detailed List</h3>
							<FullTable
								data={this.detailedTable()}
								columns={this.state.detailedStarts}
								name="starts__detailed"
								title="Starts"
								pageSize={20}
							/>
						</div>
					</div>
					{settings?.enabled?.buildTime ? (
						<div className="imageGroup">
							<div className="content">
								<h3>Build Time To Start</h3>
								<FullTable
									data={this.buildBuildTime()}
									columns={this.state.buildTimeColumns}
									name="starts__buildTime"
									title="Starts - Build Time"
									pageSize={20}
									getTrProps={this.getTrProps}
								/>
							</div>
						</div>
					) : (
						""
					)}
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Starts)
